import { applyAuth0Theme } from "@/utils/theme/themeEngine";

import MfaCountryCodesHeader from "./components/MfaCountryCodesHeader";
import MfaCountryCodesList from "./components/MfaCountryCodesList";
import { useMfaCountryCodesManager } from "./hooks/useMfaCountryCodesManager";
import { AuthLayout } from "@/components/auth/AuthLayout";

function MfaCountryCodesScreen() {
    // Extracting attributes from hook made out of MfaCountryCodes instance of Auth0 React ACUL SDK
    const { mfaCountryCodes, texts, locales } = useMfaCountryCodesManager();

    applyAuth0Theme(mfaCountryCodes);
    return (
        <AuthLayout title={texts?.pageTitle || locales?.page?.title}>

            <MfaCountryCodesHeader />
            <MfaCountryCodesList />

        </AuthLayout>
    );
}

export default MfaCountryCodesScreen;
